<!-- eslint-disable quotes -->
<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-container>
  <div> Cash Requests</div>

      <v-list two-line class="mt-n3 mb-10">
        <v-list-item
          dense
          v-for="(item, i) in PettyCashLines"
          :key="i"
          style="border: 1px solid #0a9971; border-radius: 4px"
          class="my-2"
          @click="viewItem(item)"
        >
          <v-list-item-action class="ml-n2">
            <v-icon color="primary"
              >check_circle_outline</v-icon
            ></v-list-item-action
          >
          <v-list-item-content class="ml-n4">
            <v-list-item-title class="teal--text">
              {{ item.accountNo }}
              <v-chip
                small
                :color="getStatusColor(item.paymentStatus)"
                class="text-white"
                >{{ item.paymentStatus }}</v-chip
              >
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <div class="d-flex justify-end">
            {{ item.amount | currency }}
          </div>

        </v-list-item>
      </v-list>
      <!-- <Search :search="search" @searchInput="updateSearch" /> -->    <v-fab-transition>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        v-bind="attrs"
                        v-on="on"
                        @click="searchDialog = !searchDialog"
                        class="buttons"
                    >
                        <v-icon> {{ searchDialog ? 'mdi-close' : 'search' }} </v-icon>
                    </v-btn>
                </template>
                <span>Search Requests</span>
            </v-tooltip>
        </v-fab-transition>
        <Search :search="search" @searchInput="updateSearch" />
      <ApproveReq
        :dialog="dialog"
        :request="request"
        @closeDialog="closeDialog"
      />

  </v-container>
</template>
<script>
import ApproveReq from './ApproveReq.vue'
import { helper } from '@/packages/cetus-base/utilities'
import Search from '../../../../../cetus-base/components/Search.vue'
export default {
  name: 'CoordinatorRequests',
  components: { ApproveReq, Search },
  data: function () {
    return {
      dialog: false,
      request: {},
      search: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next((v) => {
      v.$store.dispatch('reposession/getPettyCashLines')
    })
  },
  computed: {
    PettyCashLines: function () {
      return this.$store.getters['reposession/dashboardGetter'](
        'PettyCashLines'
      ).reverse()
    },
    searchDialog: {
      set (value) {
        this.$store.dispatch('reposession/setSearchDialog', value)
      },
      get () {
        return this.$store.getters['reposession/getSearchDialog']
      }
    }

  },
  methods: {
    getStatusColor: function (status) {
      return helper.getStatusColor(status)
    },

    viewItem: function (item) {
      this.dialog = true
      this.request = item
    },
    closeDialog: function (val) {
      this.dialog = val
    },
    updateSearch (val) {
      this.search = val
    }
  }
}
</script>

<style scoped>
.name {
  font-size: 13px;
  font-weight: 600;
  font-family: "Overpass", sans-serif;
  color: black;
  text-align: center;
}
.name-text {
  font-size: 30px;
  font-weight: 500;
  text-align: center;
}
.divclass {
  font-size: 16px;
  font-weight: 600;
  font-family: "Overpass", sans-serif;
  color: black;
  text-align: center;
}
</style>
